<block-ui [delayStart]="0" [delayStop]="0" [template]="blockTemplate" [class]="template">
  <div class="authentication-wrapper authentication-3">
    <div class="authentication-inner">
      <!-- Side container -->
      <!-- Do not display the container on extra small, small and medium screens -->
      <div class="d-none d-lg-flex col-lg-8 align-items-center ui-bg-cover ui-bg-overlay-container p-5"
        [style.backgroundImage]="'url('+ imagen +')'" style="background-size: cover;">
        <div class="dejarVer">
        </div>
        <div class="ui-bg-overlay bg-dark opacity-50"></div>
        <!-- Text -->
        <div class="w-100 text-white px-5 container-text">
          <h1 class="bienvenidoTitulo">BIENVENIDO A<br>ATLAS CONMIGO</h1>
          <a class="bienvenidoCuerpo">
            Un portal diseñado para que nuestros clientes y socios de negocios hagan uso de nuestros servicios
            en línea.
          </a>
        </div>

        <!-- /.Text -->
      </div>
      <div class="d-flex col-lg-4 align-items-center bg-white p-5">
        <!-- Inner container -->
        <!-- Have to add `.d-flex` to control width via `.col-*` classes -->
        <div class="d-flex col-sm-7 col-md-5 col-lg-12 px-0 px-xl-4 mx-auto">
          <div class="w-100">

            <!-- Logo -->
            <div class="d-flex justify-content-center align-items-center">
              <div class="ui-w-60">
                <div class="w-100 position-relative">
                  <img src="assets/img/icono-atlas.png" height="60px">
                </div>
              </div>
            </div>
            <!-- / Logo -->
            <h5 class="slogan">Atlas Conmigo</h5>
            <h6 class="slogan">Asegurado</h6>
            <form class="my-4" [formGroup]="formularioAse">
              <div class="row justify-content-center align-items-center">
                <div class="row justify-content-left">
                  <mat-form-field class="col-md-10">
                    <mat-label>Email</mat-label>
                    <input type="text" matInput formControlName="Email">
                    <button mat-icon-button type="button" matSuffix>
                      @if (validandoCorreo) {
                        <mat-icon class="check-valido">check_circle</mat-icon>
                      }
                      @if (!validandoCorreo) {
                        <mat-icon>error_outline</mat-icon>
                      }
                    </button>
                    @if (formularioAse.get('Email').hasError('required')) {
                      <mat-error>
                        El campo es obligatorio
                      </mat-error>
                    }
                    @if (formularioAse.get('Email').hasError('email') || formularioAse.get('Email').hasError('pattern')) {
                      <mat-error
                        >
                        El campo email debe tener un formato valido
                      </mat-error>
                    }
                  </mat-form-field>
                  <div class="col-md-2">
                    @if (!validandoCorreo) {
                      <button mat-raised-button color="primary"
                        [disabled]="!formularioAse.get('Email').valid"
                      (click)="ValidarCorreo()">Verificar</button>
                    }
                  </div>
                  <mat-form-field class="col-md-6 my-auto"
                    [ngClass]="generaErrorPasswordForm ? 'mat-focused' : ''">
                    <mat-label>Contraseña</mat-label>
                    <input class="fuente" matInput #password formControlName="Password"
                      [type]="hide ? 'password' : 'text'">
                      <span matSuffix class="d-flex align-items-center">
                        <button mat-icon-button matSuffix (click)="hide = !hide"
                          [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        <mat-icon id="iconPass" class="mt-1"
                        [ngClass]="{'d-none': validandoPassword || generaErrorPasswordForm }">check_circle</mat-icon>
                        @if (validandoPassword) {
                          <mat-icon class="fa-spin">sync</mat-icon>
                        }
                        <mat-icon class="errors" [ngClass]="{'d-none': !generaErrorPasswordForm }"
                        >error_outline</mat-icon>
                      </span>

                      @if (formularioAse.get('Password').hasError('required')) {
                        <mat-error>
                          El campo es obligatorio
                        </mat-error>
                      }
                      @if (formularioAse.get('Password')?.hasError('formatoIncorrecto')) {
                        <mat-error>
                          La contraseña tiene un formato incorrecto
                        </mat-error>
                      }

                    </mat-form-field>

                    <mat-form-field class="col-md-6 my-auto">
                      <mat-label>Confirma Contraseña</mat-label>
                      <input class="fuente" matInput formControlName="ConfirmaPassword"
                        [type]="hide ? 'password' : 'text'">
                        <button mat-icon-button matSuffix (click)="hide = !hide"
                          [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        @if (formularioAse.get('ConfirmaPassword').hasError('required')) {
                          <mat-error>
                            El campo es obligatorio
                          </mat-error>
                        }
                        @if (formularioAse.get('ConfirmaPassword').hasError('match')) {
                          <mat-error>
                            Las contraseñas no coinciden
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-md-12 mt-4">
                        <mat-label>Alias o sobrenombre</mat-label>
                        <input class="fuente" type="text" matInput formControlName="Alias">
                        <mat-error>El campo es obligatorio</mat-error>
                      </mat-form-field>

                      <mat-form-field class="col-md-10">
                        <mat-label>Teléfono celular</mat-label>
                        <span matTextPrefix>+ &nbsp;</span>
                        <input type="number" matInput formControlName="Telefono">
                        <span matSuffix class="icon-group">
                          <button mat-icon-button type="button" matSuffix>
                            @if (validandoTelefono) {
                              <mat-icon
                              class="check-valido">check_circle</mat-icon>
                            }
                            @if (!validandoTelefono) {
                              <mat-icon>error_outline</mat-icon>
                            }
                          </button>
                        </span>

                        @if (formularioAse.get('Telefono').hasError('required')) {
                          <mat-error>
                            El campo es obligatorio
                          </mat-error>
                        }
                        @if (formularioAse.get('Telefono').hasError('pattern')) {
                          <mat-error>
                            Se requieren almenos 12 digitos, iniciando
                            con el codigo del país 52(México)
                          </mat-error>
                        }

                      </mat-form-field>
                      <div class="col-md-2">
                        @if (!validandoTelefono) {
                          <button mat-raised-button color="primary"
                            [disabled]="!formularioAse.get('Telefono').valid"
                          (click)="ValidarTelefono()">Verificar</button>
                        }
                      </div>
                      <mat-form-field class="col-md-12 mt-4">
                        <mat-label>Inicio de vigencia de la póliza</mat-label>
                        <app-input-fecha-actualizacion class="fuente" (click)="picker.open()"
                          [picker]="picker" formControlName="FechaInicioVigencia" [maxFecha]="null">
                        </app-input-fecha-actualizacion>
                        <mat-datepicker-toggle tabindex="-1" matPrefix
                        [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        @if (formularioAse.get('FechaInicioVigencia').value) {
                          <button tabindex="-1" type="button" mat-icon-button matSuffix
                            (click)="formularioAse.get('FechaInicioVigencia').reset()"
                            >
                            <i class="fa fa-times"></i>
                          </button>
                        }
                        @if (formularioAse.get('FechaInicioVigencia').hasError('required')) {
                          <mat-error>
                            El campo es obligatorio
                          </mat-error>
                        }
                      </mat-form-field>

                      <div class="col-md-12">
                        <h6 class="slogan2">Ingrese póliza vigente
                          <button type="button" mat-icon-button matSuffix>
                            <mat-icon (click)="openModalImagenAyuda()">help_outline</mat-icon>
                          </button>
                        </h6>
                      </div>
                      <!-- <div class="row justify-content-center"> -->
                      <div class="col-md-3 mt-1">
                        <mat-form-field class="inputFormulario">
                          <mat-label>Sucursal</mat-label>
                          <input minlength="3" maxlength="3" matInput formControlName="Sucursal"
                            UpperCase>
                          </mat-form-field>
                        </div>
                        <!-- <span>&nbsp;-&nbsp;</span> -->
                        <div class="col-md-3 mt-1">
                          <mat-form-field class="inputFormulario">
                            <mat-label>Linea</mat-label>
                            <input minlength="1" maxlength="1" matInput formControlName="Linea"
                              [OnlyNumber]="true">
                            </mat-form-field>
                          </div>
                          <!-- <span>&nbsp;-&nbsp;</span> -->
                          <div class="col-md-3 mt-1">
                            <mat-form-field class="inputFormulario">
                              <mat-label>Producto</mat-label>
                              <input minlength="1" maxlength="3" matInput formControlName="Producto"
                                [OnlyNumber]="true">
                              </mat-form-field>
                            </div>
                            <!-- <span>&nbsp;-&nbsp;</span> -->
                            <div class="col-md-3 mt-1">
                              <mat-form-field class="inputFormulario">
                                <mat-label>Póliza</mat-label>
                                <input minlength="1" maxlength="8" matInput formControlName="Poliza"
                                  [OnlyNumber]="true">

                                </mat-form-field>
                              </div>
                              <div class="col-md-12">
                                @if (mostrarErrorUsuario) {
                                  <mat-error>
                                    Los campos son obligatorios
                                  </mat-error>
                                }
                              </div>
                              <!-- <div class="col-md-1">
                              <button type="button" mat-icon-button>
                                <mat-icon (click)="openModalImagenAyuda()">help_outline</mat-icon>
                              </button>
                            </div> -->

                            <!-- <div class="row"> -->

                            @if (formularioAse.get('Inciso').enabled) {
                              <div class="col-md-6">
                                <mat-form-field class="inputFormulario">
                                  <mat-label>Inciso</mat-label>
                                  <input class="text-center" type="text" matInput formControlName="Inciso"
                                    [OnlyNumber]="true">
                                    <!-- <mat-hint> {{reglasDescuento.min}} - {{reglasDescuento.max}}%</mat-hint> -->
                                    <mat-error>El campo es requerido</mat-error>
                                  </mat-form-field>
                                </div>
                              }
                              @if (formularioAse.get('Ubicacion').enabled) {
                                <div class="col-md-6">
                                  <mat-form-field class="inputFormulario">
                                    <mat-label>Ubicación</mat-label>
                                    <input class="text-center" type="text" matInput formControlName="Ubicacion"
                                      [OnlyNumber]="true">
                                      <!-- <mat-hint> {{reglasDescuento.min}} - {{reglasDescuento.max}}%</mat-hint> -->
                                      <mat-error>El campo es requerido</mat-error>
                                    </mat-form-field>
                                  </div>
                                }
                                @if (formularioAse.get('Certificado').enabled) {
                                  <div class="col-md-6">
                                    <mat-form-field class="inputFormulario">
                                      <mat-label>Certificado</mat-label>
                                      <input class="text-center" type="text" matInput formControlName="Certificado"
                                        [OnlyNumber]="true">
                                        <!-- <mat-hint> {{reglasDescuento.min}} - {{reglasDescuento.max}}%</mat-hint> -->
                                        <mat-error>El campo es requerido</mat-error>
                                      </mat-form-field>
                                    </div>
                                  }
                                  @if (formularioAse.get('Seccion').enabled) {
                                    <div class="col-md-6">
                                      <mat-form-field class="inputFormulario">
                                        <mat-label>Seccion</mat-label>
                                        <input class="text-center" type="text" matInput formControlName="Seccion"
                                          [OnlyNumber]="true">
                                          <!-- <mat-hint> {{reglasDescuento.min}} - {{reglasDescuento.max}}%</mat-hint> -->
                                          <mat-error>El campo es requerido</mat-error>
                                        </mat-form-field>
                                      </div>
                                    }
                                  <!-- </div> -->
                                  <mat-form-field class="col-md-12">
                                    <mat-label>Pregunta secreta</mat-label>
                                    <mat-select formControlName="IdPregunta">
                                      @for (preguntas of catPreguntas; track preguntas) {
                                        <mat-option [value]="preguntas.Value">
                                          {{preguntas.Text}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>

                                  <mat-form-field class="col-md-12 mt-4">
                                    <mat-label>Respuesta</mat-label>
                                    <input class="fuente" type="text" matInput formControlName="Respuesta">
                                    @if (formularioAse.get('Respuesta').hasError('required')) {
                                      <mat-error>
                                        El campo es obligatorio
                                      </mat-error>
                                    }
                                  </mat-form-field>


                                </div>
                                <!-- / Form -->
                              </div>

                              <div class="d-flex justify-content-between align-items-center m-0 my-4">
                                <button mat-raised-button color="warn" (click)="registrar()"
                                  [disabled]="formularioAse.invalid">
                                  @if (!loading) {
                                    <span>REGISTRARSE</span>
                                  }
                                  @if (loading) {
                                    <span><i class="fas fa-sync fa-spin"></i> Cargando...</span>
                                  }
                                </button>
                                <button class="m-2" mat-raised-button color="primary" (click)="regresar()">Regresar</button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </block-ui>